{
	"title": "The transaction was flagged by DNV Representative as incorrect carbon allocation.",
	"description": "If necessary, use the buffer to compensate for any missing carbon reductions.",
	"adjustCarbonBalance": "Adjust carbon balance"
}
